import type { FC } from 'react'

import { StyledText } from '@skytech/ui'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { Translation } from '@/components/i18n/Translation'

export type ProductPriceProps = {
  employeePrice: number
  productPrice: number
  isSingleProductGroup: boolean
  isFromPriceTextVisible: boolean
  isProductPriceVisible: boolean
}

export const ProductPrice: FC<ProductPriceProps> = ({
  employeePrice,
  productPrice,
  isSingleProductGroup,
  isFromPriceTextVisible,
  isProductPriceVisible,
}) => (
  <div className="flex w-full flex-col gap-1 whitespace-nowrap text-left md:gap-2">
    {Boolean(isProductPriceVisible) && (
      <span className="flex flex-col items-baseline">
        <StyledText
          size="small"
          colorMode="gray"
          className="!leading-none max-sm:!text-xs sm:!mb-0.5"
        >
          {!isSingleProductGroup && isFromPriceTextVisible ? (
            <Translation id="product price from" />
          ) : (
            <Translation id="product price" />
          )}{' '}
        </StyledText>
        <StyledText
          size="regular-plus"
          colorMode="black"
          fontWeight="bold"
          className="flex flex-col !text-xs !leading-none sm:!text-sm md:!text-base"
        >
          {productPrice === 0 ? (
            <span> - </span>
          ) : (
            <FormattedNumberWithCurrency isTextBold amount={productPrice} />
          )}
        </StyledText>
      </span>
    )}

    <span className="flex flex-col items-baseline">
      <StyledText
        size="small"
        colorMode="gray"
        className="!leading-none max-sm:!text-xs sm:!mb-0.5"
      >
        {!isSingleProductGroup && isFromPriceTextVisible ? (
          <Translation id="your price from" />
        ) : (
          <Translation id="your price" />
        )}{' '}
      </StyledText>

      <StyledText
        size="xl"
        colorMode="black"
        fontWeight="bold"
        className="max-mobile:!text-lg flex flex-col !leading-none max-md:!text-xl"
      >
        {employeePrice === 0 ? (
          <Translation id="Fully covered" />
        ) : (
          <FormattedNumberWithCurrency isTextBold amount={employeePrice} />
        )}
      </StyledText>
    </span>
  </div>
)
